import React, { useState, useEffect, useCallback, useRef } from "react";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import quillEmoji from "quill-emoji";
import MagicUrl from "quill-magic-url";
import "quill-emoji/dist/quill-emoji.css";

import Scrollbar from "react-scrollbars-custom";

import { useDropzone } from "react-dropzone";
import { deleteFile, sendNewMessage } from "./../../api/chatApi";
import i18n from "./../../i18n";

const { EmojiBlot, ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } = quillEmoji;

Quill.register(
  {
    "formats/emoji": EmojiBlot,
    "modules/emoji-shortname": ShortNameEmoji,
    "modules/emoji-toolbar": ToolbarEmoji,
    "modules/emoji-textarea": TextAreaEmoji,
    "modules/magicUrl": MagicUrl,
  },
  true
);
function ConversationFooter({ messageToId, isGroup, getConversationContent }) {
  let textBody = useRef(null);
  //Text editor
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
    "emoji-toolbar": false,
    "emoji-textarea": true,
    "emoji-shortname": false,
    magicUrl: true,
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
    "emoji",
  ];

  //Emoji popup
  // const [emojiPop, toggleEmoji] = useState(false);
  // const toggleEmojiPop = () => toggleEmoji(!emojiPop);

  // const [chosenEmoji, setChosenEmoji] = useState(null);
  // const onEmojiClick = (event, emojiObject) => {
  //   setChosenEmoji(emojiObject);
  // };

  //Message text
  const [message, setMessage] = useState("");
  // console.log("message", message);

  //File uploading

  useEffect(() => {
    setMessage("");
    setMyFiles([]);
  }, [messageToId, isGroup]);

  // useEffect(() => {
  //   if (textBody && textBody.current) textBody.current.focus();
  // }, [textBody]);

  const [myFiles, setMyFiles] = useState([]);
  const onDrop = useCallback(
    (acceptedFiles) => {
      setMyFiles([...myFiles, ...acceptedFiles]);
      var formData = new FormData();

      for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append(acceptedFiles[i].name, acceptedFiles[i]);
      }

      console.log(formData);

      //formData.append("files", acceptedFiles);
      fetch("api/messenger/upload-files", {
        method: "POST",
        body: formData,
      });
    },
    [myFiles]
  );

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: ".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf",
    multiple: true,
    onDrop,
  });

  const removeFile = async (file) => {
    const newFiles = [...myFiles];
    const index = newFiles.indexOf(file);

    await deleteFile(index);

    newFiles.splice(index, 1);
    //console.log("newFiles", newFiles);
    setMyFiles(newFiles);
  };

  const sendMessage = async () => {
    //console.log("message trim =>", message.trim());
    if (!message.replace(/<[^>]+>/g, "").trim()) return;
    await sendNewMessage({ messageToId, isGroup, messageText: message });
    setMessage("");
    setMyFiles([]);
    //getConversationContent(messageToId, isGroup, false)
  };

  // lastModified: 1554376967214
  // lastModifiedDate: Thu Apr 04 2019 15:22:47 GMT+0400 (Georgia Standard Time) {}
  // name: "logos.pdf"
  // path: "logos.pdf"
  // preview: "blob:http://localhost:3000/2bac13fe-f3c5-441c-853c-500d07b6ed27"
  // size: 1026818
  // type: "application/pdf"

  const files = myFiles.map((file, index) =>
    file.type === "image/png" ||
    file.type === "image/jpeg" ||
    file.type === "image/jpg" ||
    file.type === "image/gif" ? (
      <div className="file-item" key={file.name}>
        <button
          type="button"
          className="remove-btn"
          onClick={() => removeFile(file)}
        >
          <span className="material-icons">close</span>
        </button>
        <img
          src="https://image.flaticon.com/icons/svg/3069/3069204.svg"
          alt={file.name}
        />
        <div className="file-info">
          <h4 title={file.name}>{file.name}</h4>
          <p>{Number.parseFloat(file.size / (1024 * 1024)).toFixed(2)} MB</p>
        </div>
      </div>
    ) : (
      <div className="file-item" key={file.name}>
        <button
          type="button"
          className="remove-btn"
          onClick={() => removeFile(file)}
        >
          <span className="material-icons">close</span>
        </button>
        <img src="https://image.flaticon.com/icons/svg/546/546391.svg" alt="" />
        <div className="file-info">
          <h4>{file.name}</h4>
          <p>{Number.parseFloat(file.size / (1024 * 1024)).toFixed(2)} MB</p>
        </div>
      </div>
    )
  );

  //console.log("files ", files);

  return (
    <div className="chat-footer">
      {files.length > 0 && (
        <aside className="file-horisontal-list ">
          <Scrollbar>
            <div className="d-flex">{files}</div>
          </Scrollbar>
        </aside>
      )}

      <div className="form-row">
        <div className="col">
          <div className="input-group">
            <div className="custom-actions-tool">
              {/* {emojiPop ? (
                <div className="emoji-pop">
                  <Picker onEmojiClick={onEmojiClick} />
                </div>
              ) : (
                ""
              )}
              <div className="btn-item emoji" onClick={toggleEmojiPop}>
                <span className="material-icons">emoji_emotions</span>
              </div> */}

              <div
                className="btn-item upload"
                {...getRootProps({ className: "dropzone" })}
              >
                <input {...getInputProps()} />
                <span className="material-icons">attachment</span>
              </div>
              <div className="btn-item send" onClick={sendMessage}>
                <span className="material-icons">send</span>
              </div>
            </div>

            <div className="chat-text-input">
              <ReactQuill
                theme="snow"
                value={message}
                onChange={setMessage}
                modules={modules}
                formats={formats}
                placeholder={i18n.t("type.the.message")}
                ref={textBody}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversationFooter;
